import Vue from 'vue';
import VueRouter from 'vue-router';

/* Authentication */
import Auth from './components/auth/Auth.vue';
import Login from './components/auth/Login.vue';
import Register from './components/auth/Register.vue';
import Forget from './components/auth/Forget.vue';

/* NavBar Pages */
import Cart from './components/Cart.vue';
import Checkout from './components/Checkout.vue';

import Catalog from './components/Catalog.vue';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';

import Home from './components/Home.vue';
import KH_calibration from './components/KH_calibration.vue';
import KH_graph from './components/KH_graph.vue';
import KH_settings from './components/KH_settings.vue';
import CaRx_settings from './components/CaRx_settings.vue';
import CaRx_graph from './components/CaRx_graph.vue';
import KH_dosing from './components/KH_dosing.vue';
import KH_cal_solution from './components/KH_cal_solution.vue';
import my_kh from './components/My_KH.vue';

import Product from './components/Product.vue';
import Profile from './components/Profile.vue';
import Transaction from './components/Transaction.vue';

//import WifiSetup from './components/WifiSetup.vue';

/**
 * Map navigator language to our language values.
 *
 * @param {any} lang
 */
export function mapLang(defLang) {
    let lang = defLang || navigator.language || navigator.userLanguage;
    const lower = lang.toLowerCase();
    if (lower === 'zh-tw' || lower === 'zh-hk' || lower.match(/tw/)) {
        return 'tw';
    } else if (lower === 'zh-cn') {
        return 'cn';
    } else if (lower === 'vi' || lower ==='vi_VN') {
        return 'vi';
    } else if (lower === 'ms' || lower ==='ms_MY') {
        return 'ms';
    } else {
        return 'en';
    }
}

function propsLang(route) {
    Log.info('route: ', route.params);
    return {
        language: mapLang()
    }
}

const Default = { template: "<div>MAIN DISPLAY TBD</div>" };
const DefLang = mapLang();
const routes = [
    {
        path: '/',
        redirect: '/product/' + DefLang,
    },
    {
        path: '/product/:language',
        name: 'product',
        components: {
            'default': Product,
            'header-top': Header,
            'header-bottom': Footer,
            params: { langauge: DefLang }
        },
        meta: { requiresAuth: false },
        props: true
    },
    {
        path: '/cart/:language',
        name: 'cart',
        components: {
            'default': Cart,
            'header-top': Header,
            // params: { langauge: DefLang }
        },
        meta: { requiresAuth: false },
        props: true
    },
    {
        path: '/checkout/:language',
        name: 'checkout',
        components: {
            'default': Checkout,
            'header-top': Header,
            params: { langauge: DefLang }
        },
        meta: { requiresAuth: false },
        props: true
    },
    {
        path: '/transaction/:language',
        name: 'transaction',
        components: {
            'default': Transaction,
            'header-top': Header,
        },
        meta: { requiresAuth: false },
        props: true
    },
    {
        path: '/catalog/:language',
        name: 'catalog',
        components: {
            'default': Catalog,
            'header-top': Header,
            params: { langauge: DefLang }
        },
        meta: { requiresAuth: false },
        props: true
    },
    {
        path: '/home/:language',
        name: 'home',
        components: {
            'default': Home,
            'header-top': Header,
            params: { langauge: DefLang }
        },
        meta: { requiresAuth: false },
        props: true
    },
    {
        path: '/my-kh/:language',
        name: 'my-kh',
        components: {
            'default': my_kh,
            'header-top': Header,
            params: { langauge: DefLang }
        },
        meta: { requiresAuth: true },
        props: true
    },
    /*
    {
        path: '/wifi-setup/:language',
        name: 'wifi',
        components: {
            'default': WifiSetup,
            'header-top': Header,
            params: { langauge: DefLang }
        },
        meta: { requiresAuth: true },
        props: true
    },*/
    {
        path: '/kh-settings/:language',
        name: 'kh-settings',
        components: {
            'default': KH_settings,
            'header-top': Header,
            params: { langauge: DefLang, sidx: 0}
        },
        meta: { requiresAuth: true },
        props: true
    },
    {
        path: '/CaRx-settings/:language',
        name: 'CaRx-settings',
        components: {
            'default': CaRx_settings,
            'header-top': Header,
            params: { langauge: DefLang, sidx: 0 }
        },
        meta: { requiresAuth: true },
        props: true
    },
    {
        path: '/CaRx-graph/:language',
        name: 'CaRx-graph',
        components: {
            'default': CaRx_graph,
            //'header-top': Header,
            params: { langauge: DefLang, sidx: 0 }
        },
        meta: { requiresAuth: false },
        props: true
    },    
    {
        path: '/kh-dosing/:language',
        name: 'kh-dosing',
        components: {
            'default': KH_dosing,
            'header-top': Header,
            params: { langauge: DefLang, sidx: 0 }
        },
        meta: { requiresAuth: true }
    },
    {
        path: '/kh-calsolution/:language',
        name: 'kh-calsolution',
        components: {
            'default': KH_cal_solution,
            'header-top': Header,
            params: { langauge: DefLang, sidx: 0 }
        },
        meta: { requiresAuth: true }
    },
    {
        path: '/kh-calibration/:language',
        name: 'kh-calibration',
        components: {
            'default': KH_calibration,
            'header-top': Header,
            params: { langauge: DefLang, sidx: 0 }
        },
        meta: { requiresAuth: true }
    },
    {
        path: '/kh-graph/:language',
        name: 'kh-graph',
        components: {
            'default': KH_graph,
            //'header-top': Header,
            params: { langauge: DefLang, sidx: 0}
        },
        meta: { requiresAuth: false },
        props: true
    },
    {
        path: '/profile/:language',
        name: 'profile',
        components: {
            'default': Profile,
            'header-top': Header,
            params: { language: DefLang }
        },
        meta: { requiresAuth: true }
    },
    {
        path: '/auth/:language',
        name: 'auth',
        // component: Auth,
        redirect: {
            name: 'entry',
            params: {
                language: DefLang
            }
        },
        components: {
            'default': Auth,
            'header-top': Header,
            //'header-bottom': Footer,
            params: { language: DefLang }
        },
        children: [{
            path: 'login',
            name: 'entry',
            props: true,
            components: {
                'default': Login,
                // 'header-top': Header,
                params: {language: DefLang }
            },
            meta: { requiresAuth: false }
        },
        {
            path: 'register',
            name: 'register',
            props: true,
            components: {
                'default': Register,
                // 'header-top': Header,
                params: {language: DefLang }
            },
            meta: { requiresAuth: false }
        },
        {
            path: 'forget',
            name: 'forget',
            props: true,
            components: {
                'default': Forget,
                // 'header-top': Header,
                params: {language: DefLang }
            },
            meta: { requiresAuth: false }
        }
        ]
    },
    // { path: '/redirect-me', redirect: { name: 'home', params: { language: DefLang } } },
    // { path: '*', redirect: '/auth' }
];

Vue.use(VueRouter);

const router = new VueRouter({
    routes: routes,
    mode: 'history'
});

export default router;


// WEBPACK FOOTER //
// ./src/routes.js